<input-color-picker
  [label]="to.label"
  [value]="formControl.value"
  (valueChange)="onColorChange($event)"
/>
@if (to.description) {
  <div class="description">{{ to.description }}</div>
}
